// 前台登入 component

<template>
  <div class="login-layout">
    <p class="app-info"><small>Powered By ICT - v{{version}}</small></p>
    <div class="top-panel" @click="closeScreenSaver" v-show="showSaver" id="top-panel">
      <div class="logo-wrap">
        <!--<img src="../assets/img/autoIX_logo.png" alt="">-->
        <p>電子藥櫃操作系統</p>
        <hr>
        <p>
          <img class="connect-icon" src="/static/svg/wifi-green.svg" alt="connected" v-if="connected" id="connected-icon">
          <img class="connect-icon" src="/static/svg/wifi-red.svg" alt="disconnected" id="disconnected-icon" v-else>
          <span>{{ connectionMsg }}</span>
          <p v-if="connected"><small>Last connected time: {{ lastConnectedTime }}</small></p>
          <p v-else><small>Last retry time: {{ lastRetryTime }}</small></p>
        </p>
      </div>
      <div class="triangle-wrap">
        <p class="login-hint">點選以登入</p>
      </div>
    </div>

    <div class="bottom-panel" id="bottom-panel" v-if="$store.state.generalSetting">
      <div class="row" style="height: 100%">
        <div class="col-6 barcode-login-panel">
          <!-- barcode login -->
          
          <div class="login-method-wrap" ref="barcode">
            <ScanBarcode v-on:setBarcode="getBarcodeToLogin">
              <div class="login-type--img">
                <div>
                  <img src="/static/svg/barcode-black.svg" alt="" class="m-2">
                  <img src="/static/svg/fingerprint-black.svg" alt="" class="m-2">
                </div>
                <h4>
                  請掃描條碼 / 指紋登入 
                </h4>
                <h6>
                  <span style="color: red" v-if="$store.state.generalSetting.can_login_with_fingerprinter === false">指紋功能未開啟</span>
                  <span v-else>
                    <span style="color: green" v-if="$store.state.fingerprinterConnected">(指紋機已連線)</span>
                    <span style="color: red" v-else>(指紋機未連線)</span>
                  </span>
                </h6>

              </div>
            </ScanBarcode>
          </div>
        </div>
        <div class="line"><span></span></div>
        <div class="col-6 account-login-panel">
          <!-- account-login -->
          <form class="login-method-wrap"
            @submit.prevent="login"
            ref="password">
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text">帳號</span>
              </div>
              <!-- 20190422新增忽略在input裡enter event, 避免因多次按enter而發生異常 -->
              <input class="form-control" type="text" id="username" v-model="username" onkeypress="if (event.keyCode == 13) {return false;}">
            </div>
            <hr>
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text">密碼</span>
              </div>
              <!-- 20190422新增忽略在input裡enter event, 避免因多次按enter而發生異常 -->
              <input type="password" class="form-control" id="password" v-model="password" onkeypress="if (event.keyCode == 13) {return false;}">
            </div>
            <hr>
            <button class="btn btn-lg login-button" type="submit" id="login-submit">
              帳號登入
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import _ from 'lodash';
import moment from 'moment';
import server, { version } from '@/config';
import ScanBarcode from './flowComp/ScanBarcode';

export default {
  name: 'Login',
  data() {
    return {
      username: '',
      password: '',
      barcode: '',
      errorMsgBarcode: '',
      errorMsg: '',
      loginMode: 'password',
      showSaver: true,
      connected: false,
      connectionMsg: '藥櫃連線中',
      server,
      checkConnectionfun: null,
      lastConnectedTime: '',
      lastRetryTime: '',
      retryTimes: 0,
      version,
    };
  },
  components: {
    ScanBarcode,
  },
  methods: {
    detetmineRedirect() {
      this.$store.commit('CLOSE_MESSAGE');
      if (this.$store.state.apps.management.functions[this.$store.state.generalSetting.login_to_app].privilege) {
        this.$router.push({ name: this.$store.state.generalSetting.login_to_app });
      } else {
        this.$router.push({ name: 'Main' });
      }
    },
    closeScreenSaver() {
      if (this.connected) {
        this.showSaver = false;
        setTimeout(() => { this.showSaver = true; }, 30000);
      }
      if (process.env.NODE_ENV === 'development') {
        this.showSaver = false;
        setTimeout(() => { this.showSaver = true; }, 30000);
      }
    },
    login() {
      return this.$store.dispatch('loginAndGetUser', {
        username: this.username,
        password: this.password,
      })
      .then(async () => {
        this.$store.commit('SHOW_LOADER', true);
        //20190520 add by aaron
        this.$store.commit('RESET_DRUG_IN_DEVICE_MODULE', true);
        await this.$store.dispatch('getSystemInfo');
        await this.$store.dispatch('getDrugInDevices');
        this.$store.dispatch('setOnline');
        this.detetmineRedirect();
      })
      .catch((err) => {
        this.$store.commit('SHOW_LOADER', false);
        console.error(err);
        if (err.response !== undefined) {
          this.$store.commit('SET_MESSAGE', {
            type: 'error',
            context: '帳號或密碼錯誤',
          });
        } else {
          this.$store.commit('SET_MESSAGE', {
            type: 'error',
            context: '伺服器連線失敗',
          });
        }
      });
    },
    getBarcodeToLogin(val) {
      if (this.connected) {
        this.$store.dispatch('barcodeLoginAndGetUser', {
          barcode: val,
        })
        .then(async () => {
          this.$store.commit('SHOW_LOADER', true);
          //20190520 add by aaron
          this.$store.commit('RESET_DRUG_IN_DEVICE_MODULE', true);
          await this.$store.dispatch('getSystemInfo');
          await this.$store.dispatch('getDrugInDevices');
          this.$store.dispatch('setOnline');
          this.detetmineRedirect();
        })
        .catch((err) => {
          this.$store.commit('SHOW_LOADER', false);
          if (err.response !== undefined) {
            this.$store.commit('SET_MESSAGE', {
              type: 'error',
              context: '條碼登入失敗',
            });
          } else {
            this.$store.commit('SET_MESSAGE', {
              type: 'error',
              context: '伺服器連線失敗',
            });
          }
        });
      } else {
        this.$store.commit('SET_MESSAGE', {
          type: 'error',
          context: '請確認系統連線狀況',
        });
      }
    },
    getFingerprintToLogin(feature) {
      if (this.connected) {
        this.$store.dispatch('fingerpinrtLoginAndGetUser', {
          feature,
        })
        .then(async () => {
          this.$store.commit('SHOW_LOADER', true);
          //20190520 add by aaron
          this.$store.commit('RESET_DRUG_IN_DEVICE_MODULE', true);
          await this.$store.dispatch('getSystemInfo');
          await this.$store.dispatch('getDrugInDevices');
          this.$store.dispatch('setOnline');
          this.detetmineRedirect();
        })
        .catch((err) => {
          this.$store.commit('SHOW_LOADER', false);
          if (err.response !== undefined) {
            this.$store.commit('SET_MESSAGE', {
              type: 'error',
              context: '指紋登入失敗',
            });
          } else {
            this.$store.commit('SET_MESSAGE', {
              type: 'error',
              context: '伺服器連線失敗',
            });
          }
          // fire again
          this.$store.dispatch('sendScanFingerCommand');
        });
      } else {
        this.$store.commit('SET_MESSAGE', {
          type: 'error',
          context: '請確認系統連線狀況',
        });
        // fire again
        this.$store.dispatch('sendScanFingerCommand');
      }
    },
    // checkConnectionRepeatly() {
    //   if (this.checkConnectionfun === null) {
    //     this.checkConnectionfun = setInterval(async () => {
    //       console.log('check connection every 10 secs.', this.connected);
    //       if (this.connected === false) {
    //         this.retryTimes += 1;
    //       }
    //       if (this.retryTimes === 30) { // retry one minutes already
    //         this.$store.commit('SET_MESSAGE', {
    //           type: 'error',
    //           context: '嘗試重新連線超過五分鐘，請與管理員聯繫',
    //           confirm: true,
    //         });
    //       }
    //       if (this.connected) {
    //         clearInterval(this.checkConnectionfun);
    //         this.checkConnectionfun = null;
    //       }
    //     }, 10000);
    //   }
    // },
    debounceDetction: _.debounce((vm) => {
      if (vm.systemLayoutChecked) {
        vm.connected = true;
        vm.connectionMsg = '藥櫃系統掃描完成';
        vm.lastConnectedTime = moment().format('HH:mm:ss');
        vm.checkFingerprint();
      } else {
        vm.connected = false;
        vm.connectionMsg = '藥櫃系統掃描失敗';
        vm.lastRetryTime = moment().format('HH:mm:ss');
      }
    }, 2000),
    checkSystemSerial() {
      // if serial number is recorded, then scan layout directly.
      if (this.$store.state.cabinetSerials.length === 0) {
        this.$store.dispatch('resetAndGetLocalSerialNumber');
      } else {
        this.$store.dispatch('sendScanLocalLayoutCommand');
      }
    },
    checkFingerprint() {
      if (this.$store.state.generalSetting.can_login_with_fingerprinter) {
        this.$store.dispatch('sendScanFingerCommand');
      }
    },
  },
  computed: {
    systemLayoutChecked() {
      return this.$store.state.systemLayoutChecked;
    },
    connectionStatus() {
      return this.$store.state.connectionStatus;
    },
    fingerprint() {
      return this.$store.state.user.fingerprint;
    },
    webSocketReady() {
      return this.$store.state.webSocketReady;
    },
  },
  mounted() {
    if (this.$store.state.webSocket.readyState === 1) {
      this.$store.dispatch('sendCancelFingerCaptureCommand');
      setTimeout(() => {
        this.checkSystemSerial();
      }, 500);
    }
    this.lastRetryTime = moment().format('HH:mm:ss');
  },
  created() {
    this.$store.dispatch('webSocketConnect');
    this.$store.commit('SET_APP', '登入');
  },
  destroyed() {
    clearInterval(this.checkConnectionfun);
    this.$store.dispatch('sendCancelFingerCaptureCommand');
  },
  watch: {
    systemLayoutChecked(val) {
      this.debounceDetction(this);
    },
    fingerprint(val) {
      this.getFingerprintToLogin(val);
    },
    webSocketReady(val) {
      if (val === true) {
        this.$store.dispatch('sendCancelFingerCaptureCommand');
        setTimeout(() => {
          this.checkSystemSerial();
        }, 500);
        this.lastRetryTime = moment().format('HH:mm:ss');
      }
    },
  },
};
</script>

<style lang="sass" scoped>
.login-layout
  height: 740px
  position: relative


.barcode-login-panel, .account-login-panel
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;

.login-mode-button-wrap
  height: 100px;
  display: flex;
  flex-flow: row;
  width: 300px;
  
.line
  width: 0px
  height: 30%;
  top: 36%;
  position: absolute
  -webkit-backface-visibility: hidden;
  border: 1px solid rgba(0, 0, 0, 0.3)
  left: 50%
  span
    position: absolute
    left: -8px
    top: calc(50% - 10px)
    background-color: white
    padding: 20px 0

.login-type--img
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  img
    width: 80px
  h4
    margin: 10px 0 20px 0

.login-method-wrap
  width: 70%
  height: 100%
  padding: 2%
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  .row
    margin-left: 0
    margin-right: 0
  
.top-panel, .bottom-panel
  position: absolute
  top: 0px
  left: 0px
  width: 100%
  height: 100%
  // box-shadow: 0 1px 5px rgba(0, 0, 0, 0.2), 0 2px 2px rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12);


@keyframes AnimationBack
  0%
    background-position: 50% 0%
  50%
    background-position: 100% 100%
  100%
    background-position: 50% 0%

.top-panel
  z-index: 10
  padding: 15px 0
  background: linear-gradient(to bottom, rgba(255,255,255,1) 0%, rgba(255,255,255,1) 50%, rgba(95,158,160,1) 100%);
  margin: 0 -15px;
  width: calc(100% + 30px);
  // border-radius: 10px;
  display: flex
  flex-direction: column
  align-items: center
  justify-content: center
  animation: AnimationBack 10s ease infinite;
  background-size: 150% 150%;
  .logo-wrap
    height: 50%;
    background-color: transparent
    display: flex
    flex-flow: column;
    justify-content: center
    text-align: center
    align-items: center
    // border: 1px solid black
    border-radius: 50%
    padding: 10%
    .form-group
      width: 90%

.bottom-panel
  z-index: 9
  margin: 0 -15px;
  width: calc(100% + 30px);
  // border-radius: 10px;
  // background: linear-gradient(to bottom, rgba(255,255,255,1) 0%, rgba(255,255,255,1) 50%, rgba(95,158,160,1) 100%);
  background: linear-gradient(180deg, #ffffff, #ffffff, #5f9ea0);
  animation: AnimationBack 10s ease infinite;
  background-size: 150% 150%;
  .row
    margin: 0px
    
.login-button
  width: 100%
  background-color: cadetblue
  color: white

.connect-icon
  width: 30px
  margin-right: 10px

@keyframes flash
  0% 
    opacity: 0;
  20%
    opacity: 0;
  40%
    opacity: 0;
  60%
    opacity: 1;
  80%
    opacity: 1;
  100% 
    opacity: 1;

         


.triangle-wrap
  position: absolute
  bottom: 10px

  .triangle-up
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 0 10px 10px 10px;
    border-color: transparent transparent #ffffff transparent
    margin-bottom: 10px
    animation: flash 2s infinite ease
    &:nth-child(3)
      animation-delay: 0s
    &:nth-child(2)
      animation-delay: 0.5s
    &:nth-child(1)
      animation-delay: 1s

.login-hint
  color: white
  transition:

.app-info
  position: absolute
  bottom: 0
  right: 0
  color: gainsboro
  z-index: 12

</style>




// WEBPACK FOOTER //
// Login.vue?44219326